import { backendURL } from "../utils/constants/constants";


export async function paypalDisconect({ typeUser, token }) {
    try {
        const response = await fetch(`${backendURL}/paypal/revoke/${typeUser}`, {
            method: 'GET',
            headers: {
                'Authorization': token
            }
        });
        return response;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function validateCupon({ cuponBody, token }) {
    try {
        const response = await fetch(`${backendURL}/cuponcode/validateCupon`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(cuponBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}


export async function createOrder({ orderBody, token }) {
    try {
        const response = await fetch(`${backendURL}/paypal/createOrder`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(orderBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

export async function saveAuthorization({ authorizationBody, token }) {
    try {
        const response = await fetch(`${backendURL}/paypal/saveAuthorization`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(authorizationBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}

//No se usó
export async function getTotalDiscount({ cartBody, token }) {
    try {
        const response = await fetch(`${backendURL}/paypal/preliquidar`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(cartBody)
        });
        const data = await response.json();
        return data;
    } catch (e) {
        window.alert('We could not complete your request at the moment, please try again later')
        window.location.reload();
        throw (e);
    }
}